import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { WorkOrderDeclinedOperationsEntityEffects } from './work-order-declined-operations.effects';

@NgModule({
  imports: [CommonModule, EffectsModule.forFeature([WorkOrderDeclinedOperationsEntityEffects])],
})
export class WorkOrderDeclinedOperationsEntityModule {}
